<script>
import { provide, computed, ref } from "vue";

export default {
  name: "Tabs",
  props: {
    modelValue: {
      type: [String, Number],
    },
    style: {
      type: String,
      default: "default",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { slots, emit }) {
    const active = computed(() => props.modelValue);
    const tabs = ref([]);

    function selectTab(tab) {
      emit("update:modelValue", tab);
    }

    provide("tabsState", {
      active,
      tabs,
    });

    return {
      tabs,
      active,
      selectTab,
    };
  },
};
</script>

<template>
  <div>
    <ul class="flex gap-1">
      <li

        v-for="(tab, i) of tabs"
        :data-ui="'tab_'+i"
        :key="i"
        :class="
                  tab.props.tabClass + ' ' + (active === i ? style === 'default' ? 'bg-primary p-2 py-2 cursor-pointer max-w-123': 'bg-white p-2 py-2 cursor-pointer max-w-123' : 'text-white bg-trader-darker-gray p-2  mt-1  cursor-pointer')
              "
        class="dark:rounded-t"
        @click="selectTab(i)"
      >
        {{ tab.props.title }}
      </li>
    </ul>
    <div class="content p-2" :class="{ 'bg-primary' : style === 'default', 'bg-white' : style === 'white'}">
      <slot />
    </div>
  </div>
</template>

